import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1A4D6D] text-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <h3 className="text-lg font-bold mb-4">おかやま健康製薬株式会社</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              岡山から全国へ。全世代の健康をサポートする信頼のサプリメントをお届けします。
            </p>
          </div>

          <div>
            <h3 className="text-base font-bold mb-4 uppercase">お問い合わせ</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:0860123456" className="hover:text-white transition-colors">
                  086-012-3456
                </a>
              </p>
              <p className="flex items-center">
                <i className="ri-printer-line mr-2"></i>
                086-012-3457
              </p>
              <p className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <a href="mailto:info@okayama-health.co.jp" className="hover:text-white transition-colors">
                  info@okayama-health.co.jp
                </a>
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-base font-bold mb-4 uppercase">サイトマップ</h3>
            <nav className="space-y-2 text-sm">
              <Link to="/products" className="block text-gray-300 hover:text-white transition-colors">
                商品一覧
              </Link>
              <Link to="/philosophy" className="block text-gray-300 hover:text-white transition-colors">
                私たちの想い
              </Link>
              <Link to="/safety" className="block text-gray-300 hover:text-white transition-colors">
                安心・安全への取り組み
              </Link>
              <Link to="/company" className="block text-gray-300 hover:text-white transition-colors">
                会社概要
              </Link>
              <Link to="/contact" className="block text-gray-300 hover:text-white transition-colors">
                お問い合わせ
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="text-base font-bold mb-4 uppercase">営業時間</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p>平日 9:00 - 18:00</p>
              <p className="text-xs">定休日：土曜日・日曜日・祝日</p>
              <p className="mt-4 text-xs">
                〒700-0000<br />
                岡山市北区○○町1-2-3
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-400">
            <p>&copy; 2024 おかやま健康製薬株式会社. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}